import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_FIGHT_API,
  headers: {
    Authorization: process.env.REACT_APP_FIGHT_TOKEN || '',
  },
});

export default api;
  